export default __webpack_public_path__ + "static/media/unknown.2a222dac.gif";